/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_CatcodeInputs */

const fr_rooms_catcode = /** @type {(inputs: Rooms_CatcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`catcode (Reservit)`)
};

const en_rooms_catcode = /** @type {(inputs: Rooms_CatcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`catcode (Reservit)`)
};

/**
* | output |
* | --- |
* | "catcode (Reservit)" |
*
* @param {Rooms_CatcodeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_catcode = /** @type {((inputs?: Rooms_CatcodeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_CatcodeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_catcode(inputs)
	return en_rooms_catcode(inputs)
});